interface AgentData {
  id: string;
  name: string;
  description: string | null;
  isPreBuilt: boolean;
  status: string;
  version: number;
  runCount?: number;
  creatorName?: string;
  lastInvokedAt: string | null;
}

interface Props {
  agent: AgentData;
  onClick: () => void;
  onRun?: () => void;
  onEdit?: () => void;
  canEdit?: boolean;
}

export function AgentCard({ agent, onClick, onRun, onEdit, canEdit }: Props) {
  const isCreating = agent.status === 'creating';

  return (
    <div className={`agent-card ${isCreating ? 'creating' : ''}`} onClick={onClick}>
      <div className={`agent-icon ${agent.isPreBuilt ? 'prebuilt' : ''}`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
      <div className="agent-body">
        <div className="agent-title-row">
          <span className="agent-title">{agent.name}</span>
          <span className="agent-type-badge">{agent.isPreBuilt ? 'Pre-built' : 'Custom'}</span>
          {isCreating && <div className="agent-creating-spinner" />}
        </div>
        <div className="agent-desc">{agent.description ?? 'No description'}</div>
        <div className="agent-meta">
          <span className="agent-stat">v{agent.version} · {agent.runCount ?? 0} runs</span>
          <span className="agent-stat">by {agent.creatorName ?? (agent.isPreBuilt ? 'Cade' : 'Unknown')}</span>
        </div>
      </div>
      <div className="hover-actions">
        {onRun && (
          <button className="hover-btn run" onClick={(e) => { e.stopPropagation(); onRun(); }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
            Run
          </button>
        )}
        {canEdit && onEdit && (
          <button className="hover-btn" onClick={(e) => { e.stopPropagation(); onEdit(); }}>
            Edit
          </button>
        )}
      </div>
    </div>
  );
}
